import { useFormikContext } from "formik";
import ReCAPTCHA from "react-google-recaptcha";

const RecaptchaInput = ({ name }: any) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div>
      <ReCAPTCHA
        sitekey="6LfWVA8iAAAAAFERHAfJEDVMhwJ8axydb2Lcuy7j"
        onChange={(value: any) => setFieldValue(name, value)}
      />
    </div>
  );
};

export default RecaptchaInput;
